module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Omset List ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "slot": "extra",
      "icon": "ios-upload-outline",
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.isModalUploadOmset = true, _vm.getOmsetCommodities()
      }
    },
    slot: "extra"
  }, [_c('span', [_vm._v("Upload Omset")])]), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tanggal Omset")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "Select date"
    },
    model: {
      value: (_vm.omsetDateSelected),
      callback: function($$v) {
        _vm.omsetDateSelected = $$v
      },
      expression: "omsetDateSelected"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-search"
    },
    on: {
      "click": function($event) {
        return _vm.getOmsetFileList()
      }
    }
  }, [_c('span', [_vm._v("Cari")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingOmsetList),
      expression: "isLoadingOmsetList"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('Table', {
    attrs: {
      "columns": _vm.columnsDataTableFile,
      "data": _vm.omsetFile,
      "loading": _vm.isLoadingOmsetFileList
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "60%"
    },
    on: {
      "on-cancel": _vm.afterUploadFileOmset
    },
    model: {
      value: (_vm.isModalUploadOmset),
      callback: function($$v) {
        _vm.isModalUploadOmset = $$v
      },
      expression: "isModalUploadOmset"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Upload File Omset")])], 1), _vm._v(" "), _c('Form', {
    ref: "uploadFileForm",
    attrs: {
      "model": _vm.formUploadOmset
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "comodityType"
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('label', [_vm._v("Pilih Tipe Komoditas :")]), _vm._v(" "), _c('Select', {
    attrs: {
      "placeholder": "Select",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.commodity_name),
      callback: function($$v) {
        _vm.commodity_name = $$v
      },
      expression: "commodity_name"
    }
  }, _vm._l((_vm.commodities), function(commodity) {
    return _c('Option', {
      key: commodity.id,
      attrs: {
        "value": commodity.commodity_name
      }
    }, [_vm._v(_vm._s(commodity.commodity_name))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commodity_name != null),
      expression: "commodity_name != null"
    }],
    attrs: {
      "prop": "file"
    }
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "name": "fileUploaded",
      "action": _vm.serverUrlUploadOmset,
      "before-upload": function (file) { return _vm.handleBeforeUploadOmset(file); }
    }
  }, [_c('div', {
    staticClass: "custom-upload"
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "20"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag files here to upload")])], 1)]), _vm._v(" "), _c('Progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProgressOmset),
      expression: "isProgressOmset"
    }],
    attrs: {
      "percent": _vm.pValueOmset,
      "stroke-width": 20
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.afterUploadFileOmset
    }
  }, [_c('span', [_vm._v("OK")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "60%"
    },
    on: {
      "on-cancel": _vm.afterUploadFileBiayaLainnya
    },
    model: {
      value: (_vm.isModalUploadBiayaLainnya),
      callback: function($$v) {
        _vm.isModalUploadBiayaLainnya = $$v
      },
      expression: "isModalUploadBiayaLainnya"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Upload File Biaya Lainnya")])], 1), _vm._v(" "), _c('Form', {
    ref: "uploadFileForm",
    attrs: {
      "model": _vm.formUploadBiayaLainnya
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "comodityType"
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('label', [_vm._v("Komoditas")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "2rem"
    }
  }, [_vm._v(" :   " + _vm._s(_vm.formUploadBiayaLainnya.commodity_name))])])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('label', [_vm._v("File Omset")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "2rem"
    }
  }, [_vm._v(" :   [ ID: " + _vm._s(_vm.formUploadBiayaLainnya.id) + " ] - " + _vm._s(_vm.formUploadBiayaLainnya.filename))])])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "file"
    }
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "name": "fileUploaded",
      "action": _vm.serverUrlUploadBiayaLainnya,
      "before-upload": function (file) { return _vm.handleBeforeUploadBiayaLainnya(file); }
    }
  }, [_c('div', {
    staticClass: "custom-upload"
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "20"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag files here to upload")])], 1)]), _vm._v(" "), _c('Progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProgressBiayaLainnya),
      expression: "isProgressBiayaLainnya"
    }],
    attrs: {
      "percent": _vm.pValueBiayaLainnya,
      "stroke-width": 20
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.afterUploadFileBiayaLainnya
    }
  }, [_c('span', [_vm._v("OK")])])], 1)], 1), _vm._v(" "), _c('cHotOmsetAddDetail', {
    attrs: {
      "isModalAddDetail": _vm.isModalAddDetail,
      "dataHot": _vm.omsetRow
    },
    on: {
      "dismiss-modal": _vm.closeSubmitModal
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Detail(s)",
      "width": "90%"
    },
    model: {
      value: (_vm.isModalDetail),
      callback: function($$v) {
        _vm.isModalDetail = $$v
      },
      expression: "isModalDetail"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f90",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-paper"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Detail(s)")])], 1), _vm._v(" "), _c('Card', [_c('Table', {
    attrs: {
      "columns": _vm.columnsDataDetail,
      "data": _vm.omsetDetail
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "ok-text": "Ya",
      "cancel-text": "Tidak"
    },
    on: {
      "on-cancel": function($event) {
        _vm.confirmDescriptionHeader = ''
      }
    },
    model: {
      value: (_vm.isModalDeleteHeader),
      callback: function($$v) {
        _vm.isModalDeleteHeader = $$v
      },
      expression: "isModalDeleteHeader"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ed3f14",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('p', [_vm._v("Apakah anda yakin ingin menghapus omset?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('i', [_vm._v(" Ketik "), _c('b', [_vm._v(_vm._s(_vm.deleteHeader.containerNumber))]), _vm._v(" untuk melanjutkan !")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.deleteHeader.id),
      callback: function($$v) {
        _vm.$set(_vm.deleteHeader, "id", $$v)
      },
      expression: "deleteHeader.id"
    }
  }), _vm._v(" "), _c('Input', {
    model: {
      value: (_vm.confirmDescriptionHeader),
      callback: function($$v) {
        _vm.confirmDescriptionHeader = $$v
      },
      expression: "confirmDescriptionHeader"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.deleteHeader.containerNumber).toUpperCase() == _vm.confirmDescriptionHeader.toUpperCase()),
      expression: "(deleteHeader.containerNumber).toUpperCase() == confirmDescriptionHeader.toUpperCase()"
    }],
    attrs: {
      "type": "error",
      "long": ""
    },
    on: {
      "click": _vm.confirmDeleteHeader
    }
  }, [_vm._v("Hapus")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "90%"
    },
    model: {
      value: (_vm.isModalEditHeader),
      callback: function($$v) {
        _vm.isModalEditHeader = $$v
      },
      expression: "isModalEditHeader"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2cb7f5",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "edit"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Edit Omset")])], 1), _vm._v(" "), _c('Card', [_c('Form', {
    ref: "editHeader",
    attrs: {
      "model": _vm.editHeader
    }
  }, [_c('Form-item', [_c('div', {
    staticClass: "edit-header-grid"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "containerNumber"
    }
  }, [_vm._v("Container Number :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Container Number"
    },
    model: {
      value: (_vm.editHeader.containerNumber),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "containerNumber", $$v)
      },
      expression: "editHeader.containerNumber"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "sumOfVol"
    }
  }, [_vm._v("Sum of Vol :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Sum of Vol"
    },
    model: {
      value: (_vm.editHeader.sumOfVol),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "sumOfVol", $$v)
      },
      expression: "editHeader.sumOfVol"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "sumOfUYAD"
    }
  }, [_vm._v("Sum of UYAD :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Sum of Uyad"
    },
    model: {
      value: (_vm.editHeader.sumOfUYAD),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "sumOfUYAD", $$v)
      },
      expression: "editHeader.sumOfUYAD"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "pib"
    }
  }, [_vm._v("PIB :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "PIB"
    },
    model: {
      value: (_vm.editHeader.pib),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "pib", $$v)
      },
      expression: "editHeader.pib"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "notul"
    }
  }, [_vm._v("Notul :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Notul"
    },
    model: {
      value: (_vm.editHeader.notul),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "notul", $$v)
      },
      expression: "editHeader.notul"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "opsPort"
    }
  }, [_vm._v("Ops. Pelabuhan :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Ops. Pelabuhan"
    },
    model: {
      value: (_vm.editHeader.opsPort),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "opsPort", $$v)
      },
      expression: "editHeader.opsPort"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "trucking"
    }
  }, [_vm._v("Trucking :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Trucking"
    },
    model: {
      value: (_vm.editHeader.trucking),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "trucking", $$v)
      },
      expression: "editHeader.trucking"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "daop"
    }
  }, [_vm._v("DAOP :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "DAOP"
    },
    model: {
      value: (_vm.editHeader.daop),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "daop", $$v)
      },
      expression: "editHeader.daop"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "demurrage"
    }
  }, [_vm._v("Demurrage :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Demurrage"
    },
    model: {
      value: (_vm.editHeader.demurrage),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "demurrage", $$v)
      },
      expression: "editHeader.demurrage"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "reExport"
    }
  }, [_vm._v("Re-Export :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Re-Export"
    },
    model: {
      value: (_vm.editHeader.reExport),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "reExport", $$v)
      },
      expression: "editHeader.reExport"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "ship_cont_gz"
    }
  }, [_vm._v("Kapal/Cont. GZ :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Kapal/Cont. GZ"
    },
    model: {
      value: (_vm.editHeader.shipContGZ),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "shipContGZ", $$v)
      },
      expression: "editHeader.shipContGZ"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "form_e"
    }
  }, [_vm._v("Form E :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Form E"
    },
    model: {
      value: (_vm.editHeader.formE),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "formE", $$v)
      },
      expression: "editHeader.formE"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "ls"
    }
  }, [_vm._v("LS :")]), _c('br'), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "LS"
    },
    model: {
      value: (_vm.editHeader.ls),
      callback: function($$v) {
        _vm.$set(_vm.editHeader, "ls", $$v)
      },
      expression: "editHeader.ls"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingEditHeader
    },
    on: {
      "click": _vm.postUpdateHeader
    }
  }, [(!_vm.isLoadingEditHeader) ? _c('span', [_vm._v("Submit")]) : _c('span', [_vm._v("On process.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "ok-text": "Ya",
      "cancel-text": "Tidak"
    },
    on: {
      "on-cancel": function($event) {
        _vm.confirmDescriptionDetail = ''
      }
    },
    model: {
      value: (_vm.isModalDeleteDetail),
      callback: function($$v) {
        _vm.isModalDeleteDetail = $$v
      },
      expression: "isModalDeleteDetail"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ed3f14",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('p', [_vm._v("Apakah anda yakin ingin menghapus detail omset?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('i', [_vm._v(" Ketik "), _c('b', [_vm._v(_vm._s(_vm.deleteDetail.containerNumber))]), _vm._v(" untuk melanjutkan !")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.deleteDetail.id),
      callback: function($$v) {
        _vm.$set(_vm.deleteDetail, "id", $$v)
      },
      expression: "deleteDetail.id"
    }
  }), _vm._v(" "), _c('Input', {
    model: {
      value: (_vm.confirmDescriptionDetail),
      callback: function($$v) {
        _vm.confirmDescriptionDetail = $$v
      },
      expression: "confirmDescriptionDetail"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.deleteDetail.containerNumber).toUpperCase() == _vm.confirmDescriptionDetail.toUpperCase()),
      expression: "(deleteDetail.containerNumber).toUpperCase() == confirmDescriptionDetail.toUpperCase()"
    }],
    attrs: {
      "type": "error",
      "long": ""
    },
    on: {
      "click": _vm.confirmDeleteDetail
    }
  }, [_vm._v("Hapus")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c88063c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/omset/OmsetList.vue
// module id = 1842
// module chunks = 1